import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

/**
 * HTTP Interceptor that tracks active requests and updates the loading service.
 */
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private requestSeq = 0;

  constructor(private loadingService: LoadingService) {}

  intercept(req: HttpRequest<{}>, next: HttpHandler): Observable<HttpEvent<{}>> {
    // Must be unique per request instance (identical URL/method requests can run concurrently)
    const requestId = `${req.method}:${req.urlWithParams}:${++this.requestSeq}`;

    this.loadingService.addRequest(requestId);
    return next.handle(req).pipe(
      finalize(() => {
        this.loadingService.removeRequest(requestId);
      }),
    );
  }
}
